'use client'
import React, { PropsWithChildren } from 'react'
import styles from './styles.module.scss'

const NoData: React.FC<PropsWithChildren> = ({ children }) => {
  return <h4 className={styles.noData}>{children}</h4>
}

export default NoData
